import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { email } from '@config';
import styled from 'styled-components';
// import tunnelPic from '@images/tunnel-pic.jpg';
import tunnelBig from '@images/Boydo-Tunnel-web.jpg';
import { theme, mixins, media, Section } from '@styles';
const { colors, fontSizes, fonts } = theme;

const StyledContainer = styled(Section)`
  ${mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  background: #080a0d;
  background-image: url(${tunnelBig});
  background-size: 75%;
  background-repeat: no-repeat;
  background-position: 400px -310px;
  color: ${colors.laurelGreen};
  ${media.tablet`padding-top: 100px;`};
  div {
    width: 100%;
  }
`;

const StyledOverline = styled.h1`
  color: ${colors.laurelGreen};
  margin: 0 0 20px 3px;
  font-size: ${fontSizes.sm};
  font-family: ${fonts.SFMono};
  font-weight: normal;
  ${media.desktop`font-size: ${fontSizes.sm};`};
  ${media.tablet`font-size: ${fontSizes.smish};`};
`;
const StyledTitle = styled.h2`
  font-size: ${fontSizes.xxxl};
  color: ${colors.deepChampagne};
  line-height: 1.1;
  margin: 0;
  ${media.desktop`font-size: 70px;`};
  ${media.tablet`font-size: 60px;`};
  ${media.phablet`font-size: 50px;`};
  ${media.phone`font-size: 40px;`};
`;
const StyledSubtitle = styled.h3`
  font-size: ${fontSizes.xxl};
  line-height: 1.1;
  color: ${colors.laurelGreen};
  ${media.desktop`font-size: 70px;`};
  ${media.tablet`font-size: 60px;`};
  ${media.phablet`font-size: 50px;`};
  ${media.phone`font-size: 40px;`};
`;
const StyledDescription = styled.div`
  margin-top: 1em;
  width: 50%;
  max-width: 500px;
  line-height: 1.5;
  font-size: ${fontSizes.md};
  font-family: ${fonts.Calibre};
  a {
    ${mixins.inlineLink};
  }
`;
const StyledEmailLink = styled.a`
  ${mixins.bigButton};
  margin-top: 50px;
`;
const HeroContent = styled.div`
  width: 40% !important;
  margin-left: 160px;
  ${media.desktop`
  width: 40% !important;
  margin-left: 160px;`};
  ${media.tablet`
  width: 40% !important;
  margin-left:0;
  `};
  ${media.phablet`
  width: 100% !important;
  padding: 1em;
  margin-left: 0px;`};
  ${media.phone`
  width: 100% !important;
  padding: 1em;
  margin-left: 0px;`};
`;
const StyledOverlay = styled.div`
  display: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
`;

// const StyledImageContainer = styled.div`
//   background-image: url(${tunnelPic});
//   background-size: cover;
//   width: 100%;
//   height: 400px;
// `;

const Hero = ({ data }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), 1000);
    return () => clearTimeout(timeout);
  }, []);

  const { frontmatter, html } = data[0].node;

  const one = () => (
    <StyledOverline style={{ transitionDelay: '100ms' }}>{frontmatter.title}</StyledOverline>
  );
  const two = () => (
    <StyledTitle style={{ transitionDelay: '200ms' }}>{frontmatter.name}.</StyledTitle>
  );
  const three = () => (
    <StyledSubtitle style={{ transitionDelay: '300ms' }}>{frontmatter.subtitle}</StyledSubtitle>
  );
  const four = () => (
    <StyledDescription
      style={{ transitionDelay: '400ms' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
  const five = () => (
    <div style={{ transitionDelay: '500ms' }}>
      <StyledEmailLink href={`mailto:${email}`}>Get In Touch</StyledEmailLink>
    </div>
  );
  // const six = () => (
  //   <div style={{ transitionDelay: '600ms' }}>
  //     <StyledImageContainer>Get In Touch</StyledImageContainer>
  //   </div>
  // );

  const items = [one, two, three, four, five];

  return (
    <StyledContainer>
      <StyledOverlay></StyledOverlay>
      <HeroContent>
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={3000}>
                {item}
              </CSSTransition>
            ))}
        </TransitionGroup>
      </HeroContent>
    </StyledContainer>
  );
};

Hero.propTypes = {
  data: PropTypes.array.isRequired,
};

export default Hero;
